import { render, staticRenderFns } from "./SettingsZone.vue?vue&type=template&id=16cc4753&"
import script from "./SettingsZone.vue?vue&type=script&lang=js&"
export * from "./SettingsZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports